import{a as t}from"./chunk-RAAYCPUM.js";function b(...n){return t(u,n)}var u=(n,r)=>n-r;export{b as a};
